module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f00vi-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Henry Holt and Company, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Publishers since 1866")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("175 Fifth Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("New York, New York 10010")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.henryholt.com",
      "target": "_blank"
    }
  }, [_vm._v("www.henryholt.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Henry Holt"), _c('sup', [_vm._v("®")]), _vm._v(" and "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f00vi-02.jpg"
    }
  }), _c('sup', [_vm._v("®")]), _vm._v(" are registered trademarks"), _c('br'), _vm._v("of Henry Holt and Company, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Copyright © 2009 by Paul Auster")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Distributed in Canada by H. B. Fenn and Company Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Auster, Paul, 1947–")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Invisible / Paul Auster.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("       p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN 978-0-8050-9080-2")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. College students—Fiction. 2. Poets—Fiction. 3. Nineteen sixties—Fiction."), _c('br'), _vm._v("4. Psychological fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("PS3551.U77158 2009")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("813'.54—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("2009002237")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Henry Holt books are available for special promotions"), _c('br'), _vm._v("and premiums. For details contact: Director, Special Markets.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("First Edition 2009")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Designed by Victoria Hartman")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("1 3 5 7 9 10 8 6 4 2")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0